// Effects
import { AuthEffects } from './auth.effects';
import { VisitorsEffects } from './visitors.effects'
import { DestinationsEffects} from './destinations.effects'
import { ReasonsEffects } from './reasons.effects'
import { DestinationReasonsEffects } from './destination-reasons.effects'
import { UsersEffects } from './users.effects'


export const EFFECTS = [
  AuthEffects,
  VisitorsEffects,
  DestinationsEffects,
  ReasonsEffects,
  DestinationReasonsEffects,
  UsersEffects,
];
